// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c8ff66a2","732":"eb4840ee"}[chunkId] + ".chunk.js";
};